export default "__VITE_ASSET__CmsTOAzi__"